import api from './api';

const unwrap = (response) => {
  if (response?.data?.data !== undefined) return response.data.data;
  return response?.data ?? response;
};

const projectMoneyTrailService = {
  getMoneyTrail: async (projectId) => {
    if (!projectId) return null;
    const response = await api.get(`/projects/${projectId}/money-trail`);
    return unwrap(response);
  }
};

export default projectMoneyTrailService;
